import { useEffect, useState } from 'react';

import { isEmpty } from 'lodash';
import { useQuery } from '@apollo/client';
import ModalUtils from 'utils/ModalUtils';
import { FetchPolicy } from 'utils/enum/Core';
import CatalogQuery from 'services/graphQL/query/CatalogQuery';

const useEnumValues = ({ catalog }) => {
    const [values, setValues] = useState([]);

    const { data, loading, error } = useQuery(CatalogQuery.ENUM_VALUES, {
        variables: {
            descriptions: [catalog],
        },
        fetchPolicy: FetchPolicy.NETWORK_ONLY,
    });

    useEffect(() => {
        if (error) {
            ModalUtils.errorMessage(error?.graphQLErrors);
            return;
        }

        if (!loading && !isEmpty(data?.getEnumValues)) {
            const { getEnumValues } = data;
            const result = getEnumValues.map((item) => ({ value: item.description, label: item.description }));
            setValues([{ label: 'None', value: '' }, ...result]);
        }
    }, [data, loading, error]);

    return {
        enumValues: values,
    };
};

export default useEnumValues;
